import { render, staticRenderFns } from "./Advert3.vue?vue&type=template&id=569dad65&scoped=true&"
import script from "./Advert3.vue?vue&type=script&lang=ts&"
export * from "./Advert3.vue?vue&type=script&lang=ts&"
import style0 from "./Advert3.vue?vue&type=style&index=0&id=569dad65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569dad65",
  null
  
)

component.options.__file = "Advert3.vue"
export default component.exports